<template>
  <div class="flex justify-center my-1">
  <!-- Toggle Button -->
  <label :for="id" class="flex justify-center items-center cursor-pointer">
    <!-- toggle -->
    <div class="relative">
      <!-- input -->
      <input :id="id" type="checkbox" class="hidden" v-model='inverse' />
      <!-- line -->
      <div class="toggle__line bg-gray-500 rounded-full shadow-inner" :class='topClasses'></div>
      <!-- dot -->
      <div class="toggle__dot-neworhot absolute bg-white rounded-full shadow inset-y-0 left-0" :class='bottomClasses'>
        <p v-if='inverse' class="text-black my-auto" :class='size === "small" ? "hot-or-new-small" : "hot-or-new-large"'>New</p>
        <p v-else class="text-black my-auto" :class='size === "small" ? "hot-or-new-small" : "hot-or-new-large"'>Hot</p>
      </div>
    </div>
    <!-- label -->
    <div v-if='label' class="ml-3 text-gray-700 font-medium">{{label}}</div>
  </label>
</div>

</template>
<script>
import uuid from 'uuid'
export default {
  props:{
    value:{
      type:Boolean,
      required:true
    },
    label:{
      type:String,
      default:''
    },
    size:{
      type:String,
      default:'small'
    }
  },
  components:{
  },
  data() {
    const id = uuid.v4();
    return {
      toggleValue:this.value,
      id:'toggle_' + id
    }
  },
  computed:{
    inverse() {
      return !this.toggleValue;
    },
    topClasses() {
      return [this.width1Class, this.height1Class];
    },
    bottomClasses() {
      return [this.width2Class, this.height2Class];
    },
    width1Class() {
      if (this.size === 'small') {
        return 'w-10';
      } else {
        return 'w-16';
      }
    },
    width2Class() {
      if (this.size === 'small') {
        return 'w-6';
      } else {
        return 'w-10';
      }
    },
    height1Class() {
      if (this.size === 'small') {
        return 'h-4';
      } else {
        return 'h-6';
      }
    },
    height2Class() {
      if (this.size === 'small') {
        return 'h-6';
      } else {
        return 'h-8';
      }
    }
  },
  watch:{
    value(nv, ov) {
      console.log('V', nv, ov);
      if (nv !== this.toggleValue) {
        this.toggleValue = nv;
      }
    },
    toggleValue(nv, ov) {
      console.log('TV', nv, ov);
      if (nv !== ov && nv !== this.value) {
        this.$emit("toggle");
        this.$emit("input", this.toggleValue);
        this.$emit("change", nv, ov);
      }
    }
  },
}
</script>
<style>
.toggle__dot-neworhot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot-neworhot {
  transform: translateX(100%);
}
.hot-or-new-small {
  font-size: 0.6rem;
  padding-top:0.25rem;
  padding-left:0.25rem;
}
.hot-or-new-large {
  @apply text-sm font-bold mt-1;
}
</style>
